import React, {
  useState,
} from 'react';
import styles from './ticketExpand.module.scss';
import kdsStyles from '../common/KDSCSS/kdsScreens.module.scss';
import cn from 'classnames';
import ExpoTime from './expoTime';
import StationCard from './stationCard';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import checkBoxIcon from '@assets/images/KDSICONS/checkBox.svg';
import LessThanIcon from '@assets/images/KDSICONS/LessThanIcon.svg';
import greaterIcon from '@assets/images/KDSICONS/greaterIcon.svg'
import moment from 'moment';
import Modal from '@components/common/Modal';
import Tooltip from './ToolTip';
import kdsDragIcon from '@assets/images/KDSICONS/kdsDrag.svg';
import kdsRushIcon from '@assets/images/KDSICONS/kdsRush.svg';
import KdsTimePicker from '../common/KdsTimePicker/index';


const TicketExpandModal = (props) => {

  const { ticketExpandData, handleTicketExpandView,
    searchOverlay,
    bumpApiCall,
    prepStartAll,
    convertUTCDateToLocalDate,
    themeProperties,
    selectedObjects,
    setSelectedObjects,
    bumpApiSelected,
    getTileHeight,
    getPrepCompletedTime,
    duplicateDeviceIds,
    handleDropClick,
    prioritizedItem,
    setPriorityItem,
    isPrioritize,
    getWarning,
    colorCoding,
    setPdfUrl,
    handleDragRushApiCall,
    deviceInfo,
  } = props;
  const [currentHistoryPage, setCurrentHistoryPage] = useState(1);
  const [showBumpModal, setShowBumpModal] = useState(false);
  let totalHistoryPage = 1;
  const kdsSettings = deviceInfo?.deviceGroup?.kdsSettings;
  const innerWidth = window.innerWidth;
  const [orderModeData, setOrderModeData] = useState({});
  const [dragRushModalData, setDragRushModalData] = useState({
    isOpen: false, data: {}, modalName: '', checkData: {},
    storeId: undefined, itemId: undefined, itemName: undefined,
  });
  const columnCount = deviceInfo?.columnCount;
  const [dragRushInputTime, setDragRushInputTime] = useState({ isConformationPopUpOpen: false, hours: 0, mins: 0, seconds: 0 });


  const bumpSelected = (check, checkPrepId) => {
    let items = [];
    for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
      const element = selectedObjects[checkPrepId][i];
      items.push({
        entityId: element.entityId,
        isModifier: element.isModifier,
      });
    }
    bumpApiSelected(check, 'expoSelectedBump', items);
    handleTicketExpandView();
    for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
      const element = selectedObjects[checkPrepId][i];
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [checkPrepId]: prevState[checkPrepId].filter(
            obj => obj.entityId !== element.entityId
          ), // remove the object from the array with the corresponding id
        };
      });
    }

    // selectedObjects[checkPrepId].forEach((element, index) = {
    //   items.push({ entityId: element.entityId, isModifier: element.isModifier})
    // })
  };

  const handleBumpItemClick = () => {
    handleTicketExpandView();
    selectedObjects?.hasOwnProperty(ticketExpandData.id + '') && selectedObjects[ticketExpandData.id]?.length > 0 ? bumpSelected(ticketExpandData, ticketExpandData.id + '') : bumpApiCall(ticketExpandData, 'expo')
  }
  const getSortData = data => {
    data.sort((a, b) => {
      return a.seatNumber - b.seatNumber
    });

    const obj = {};

    data.forEach(item => {
      let { seatId } = item;

      if (!kdsSettings?.groupBySeat) {
        seatId = 1234;
      }

      if (!obj[seatId]) {
        obj[seatId] = [];
      }

      obj[seatId].push(item);
    });

    for (let key in obj) {
      let allDayItems = obj[key].filter(val => {
        const momentTime = val.plannedStartDate && moment.utc(val.plannedStartDate).local();
        const currentTime = moment();
        return val.expoStatus != 8 && currentTime > momentTime;
      });

      allDayItems = allDayItems.sort((a, b) => {
        const timeA = new Date(a.plannedStartDate).getTime();
        const timeB = new Date(b.plannedStartDate).getTime();

        if (timeA === timeB) {
          // If timing is the same, sort based on name property
          return a.name.localeCompare(b.name);
        }

        return timeA - timeB;
      });

      let scheduledItems = obj[key].filter(val => {
        const momentTime = moment.utc(val.plannedStartDate).local();
        const currentTime = moment();
        return val.expoStatus != 8 && currentTime < momentTime;
      });

      scheduledItems = scheduledItems.sort((a, b) => {
        const timeA = new Date(a.plannedStartDate).getTime();
        const timeB = new Date(b.plannedStartDate).getTime();

        if (timeA === timeB) {
          // If timing is the same, sort based on name property
          return a.name.localeCompare(b.name);
        }

        return timeA - timeB;
      });

      let completedItems = obj[key].filter(val => val.expoStatus == 8)?.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      obj[key] = [...allDayItems, ...scheduledItems, ...completedItems];

    }

    const flattenedArr = [].concat(...Object.values(obj))

    return flattenedArr;

  };

  const renderGroups = () => {
    const groups = [];
    let gpv = 0;
    let getGroupSize = (item) => {
      let a = 0;
      let modifiers = (item) => {
        if (item.length > 0) {
          item.forEach(item => {
            a++;
            if (item.modifiers.length > 0) {
              a++;
              modifiers(item.modifiers)
            }
          })
        }
      }
      let count = 0;
      for (let i = gpv; i <= item?.length; i++, count++) {
        if (item[i]?.modifiers.length > 0) {
          a++;
          modifiers(item[i].modifiers)
          if (a > 15) {
            if (count >= 9) {
              return 9
            }
            return count + 1;
          }
        }
        a++
      }
      return 9;
    }
    let ticketExpand = getSortData(ticketExpandData.expoItems)
    for (let i = 0; i <= ticketExpand.length; i += gpv) {
      gpv = getGroupSize(ticketExpand);
      const groupItems = ticketExpand.slice(i, i + gpv);
      groups.push(
        <div className='col-4 px-0 h-100'>
          <StationCard
            check={ticketExpandData}
            groupItems={groupItems}
            searchOverlay={searchOverlay}
            bumpApiCall={bumpApiCall}
            prepStartAll={prepStartAll}
            convertUTCDateToLocalDate={convertUTCDateToLocalDate}
            themeProperties={themeProperties}
            selectedObjects={selectedObjects}
            setSelectedObjects={setSelectedObjects}
            bumpApiSelected={bumpApiSelected}
            getTileHeight={getTileHeight}
            getPrepCompletedTime={getPrepCompletedTime}
            duplicateDeviceIds={duplicateDeviceIds}
            handleDropClick={handleDropClick}
            prioritizedItem={prioritizedItem}
            setPriorityItem={setPriorityItem}
            isPrioritize={isPrioritize}
            getWarning={getWarning}
            colorCoding={colorCoding}
            deviceInfo={deviceInfo}
            orderModeData={orderModeData}
            setOrderModeData={setOrderModeData}
            dragRushModalData={dragRushModalData}
            setDragRushModalData={setDragRushModalData}
          />
        </div>
      );
    }
    let tiles = groups.length >= 4 ? 6 : 3
    for (let i = groups.length; i < tiles; i++) {
      groups.push(
        <div className='col-4 px-0 h-100 mb' >
          <StationCard
            check={ticketExpandData}
            groupItems={[]}
            searchOverlay={searchOverlay}
            bumpApiCall={bumpApiCall}
            prepStartAll={prepStartAll}
            convertUTCDateToLocalDate={convertUTCDateToLocalDate}
            themeProperties={themeProperties}
            selectedObjects={selectedObjects}
            setSelectedObjects={setSelectedObjects}
            bumpApiSelected={bumpApiSelected}
            getTileHeight={getTileHeight}
            getPrepCompletedTime={getPrepCompletedTime}
            duplicateDeviceIds={duplicateDeviceIds}
            handleDropClick={handleDropClick}
            prioritizedItem={prioritizedItem}
            setPriorityItem={setPriorityItem}
            isPrioritize={isPrioritize}
            getWarning={getWarning}
            colorCoding={colorCoding}
            deviceInfo={deviceInfo}
            orderModeData={orderModeData}
            setOrderModeData={setOrderModeData}
            dragRushModalData={dragRushModalData}
            setDragRushModalData={setDragRushModalData}
          />
        </div>
      );
    }


    const totalHistoryItemsPerPage = 3;
    const startIndex = (currentHistoryPage - 1) * totalHistoryItemsPerPage;
    const endIndex = startIndex + totalHistoryItemsPerPage;
    if (groups.length > 4) {
      totalHistoryPage = 2
    }

    return groups.slice(startIndex, endIndex);
  };

  const checkPendingItems = () => {
    const expoItems = selectedObjects[ticketExpandData.id]?.length > 0 ?
      selectedObjects[ticketExpandData.id] : ticketExpandData.expoItems;
    let isPending = false;
    expoItems.forEach((item) => {
      if ((item.prepStatus > 0 && item.prepStatus < 8) || (item.buildStatus > 0 && item.buildStatus < 8)) {
        isPending = true;
        return;
      }
    })
    return isPending;
  }

  const onCloseLongPress = () => {
    setOrderModeData({ isOpenn: false });
    setPdfUrl([])
  }

  const generateDragRushModalTime = () => {
    const data = dragRushModalData?.data
    if (data) {
      const prepStatus = data?.prepStatus;
      const buildStatus = data?.buildStatus;

      if (dragRushModalData?.modalName === LABEL().KDS_DRAG) {
        if ((prepStatus === 2 || prepStatus === 5) && (data?.prepStartDate || data?.plannedPrepStartDate)) {
          return moment.utc(data?.prepStartDate || data?.plannedPrepStartDate).local().format('hh:mm A');
        }
        if ((buildStatus === 2 || buildStatus === 5) && (data?.buildStartDate || data?.plannedBuildStartDate)) {
          return moment.utc(data?.buildStartDate || data?.plannedBuildStartDate).local().format('hh:mm A');
        }
      }
      if (dragRushModalData?.modalName === LABEL().KDS_RUSH) {
        if ((prepStatus === 2) && convertUTCDateToLocalDate(new Date(data?.plannedPrepStartDate)).getTime() > (new Date().getTime())) {
          return moment.utc(data?.plannedPrepStartDate).local().format('hh:mm A');
        }
        else {
          if (buildStatus === 2 && convertUTCDateToLocalDate(new Date(data?.plannedBuildStartDate)).getTime() > (new Date().getTime())) {
            return moment.utc(data?.plannedBuildStartDate).local().format('hh:mm A');
          }
        }
      }

    }
    return false;
  }

  const checkIsDragRushModal = (modalName) => {
    return dragRushModalData?.modalName === modalName;
  }

  return (
    <div className={styles.container}>
      {/* header */}
      <div className={cn('d-flex fs-14 justify-content-md-between align-items-center p-1 text-uppercase', styles.header)} style={{ background: ticketExpandData?.warningColor }}>
        <div>#{ticketExpandData.checkHeader?.number}</div>
        <div>
          {ticketExpandData?.checkHeader?.name?.length > 4 ? (
            <Tooltip innerWidth={innerWidth} text={ticketExpandData?.checkHeader?.name}>
              {ticketExpandData?.checkHeader?.tab === true ? (
                ticketExpandData?.checkHeader?.name?.length < 4 ? (
                  ticketExpandData?.checkHeader?.name
                ) : (
                  <span> {ticketExpandData?.checkHeader?.name?.substring(0, 4)}..</span>
                )
              ) : ticketExpandData?.checkHeader?.stationNumber?.length < 4 ? (
                ticketExpandData?.checkHeader?.stationNumber
              ) : (
                <span>
                  {ticketExpandData?.checkHeader?.stationNumber?.substring(0, 4)}..
                </span>
              )}
            </Tooltip>) :
            (
              <>
                {ticketExpandData?.checkHeader?.tab === true ? (
                  ticketExpandData?.checkHeader?.name?.length < 4 ? (
                    ticketExpandData?.checkHeader?.name
                  ) : (
                    <span> {ticketExpandData?.checkHeader?.name?.substring(0, 4)}</span>
                  )
                ) : ticketExpandData?.checkHeader?.stationNumber?.length < 4 ? (
                  ticketExpandData?.checkHeader?.stationNumber
                ) : (
                  <span>
                    {' '}
                    {ticketExpandData?.checkHeader?.stationNumber?.substring(0, 4)}..
                  </span>
                )}{' '}
              </>
            )
          }
        </div>
        {kdsSettings?.displayOrderType && <div>{ticketExpandData.checkHeader?.orderTypeName}</div>}
        {kdsSettings?.displayRevenueCenter && <div>{ticketExpandData.checkHeader?.revenueCenterName}</div>}
        <div>{ticketExpandData.checkHeader?.employeeFirstName}&nbsp;{ticketExpandData.checkHeader?.employeeLastName}</div>
        <div>
          <ExpoTime date={ticketExpandData.plannedStartDate} />
        </div>
        <div role='button' style={{ border: '1px solid white', borderRadius: '15%' }} className='d-flex align-items-center justify-content-center p-1' onClick={() => handleTicketExpandView(null)}>
          <svg xmlns="http://www.w3.org/2000/svg" height="1.5vw" viewBox="0 0 512 512" style={{ fill: "#ffff" }}><path d="M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z" /></svg>
        </div>
      </div>
      {/* body content*/}

      <div className={cn("row col-12 mr-0 ml-0 px-1", styles.body)} >{renderGroups()}</div>;

      <div className={cn('d-flex justify-content-between align-items-center', styles.footer)}>
        <div role='button' className={styles.LeftArrow} style={{ backgroundColor: currentHistoryPage - 1 === 0 ? "gray" : '#6A4DAE' }} onClick={() => {
          if (currentHistoryPage > 1) {
            let page = currentHistoryPage - 1;
            setCurrentHistoryPage(page);
          }
        }}>

          <img
            src={LessThanIcon}
            alt="LessThanIcon"
            width="12px"
          />
          <span className={styles.Zero}>{currentHistoryPage - 1}</span>
        </div>
        <div role='button' className={cn('d-flex align-items-center justify-content-center p-0', styles.button)} style={{ backgroundColor: '#0060FF', color: 'white' }}
          onClick={() => {
            checkPendingItems() ? setShowBumpModal(true) : handleBumpItemClick()
          }}
        >
          {selectedObjects?.hasOwnProperty(ticketExpandData.id + '') && selectedObjects[ticketExpandData.id].length > 0 &&
            <img src={checkBoxIcon} alt="bump selected" width="20px" />}
          <span className='pl-1'>{LABEL().KDS_BUMP}</span>
        </div>
        <div role='button' className={cn(styles.LeftArrow)}
          style={{ backgroundColor: totalHistoryPage - currentHistoryPage === 0 ? "gray" : '#6A4DAE' }}
          onClick={() => {
            if (currentHistoryPage < totalHistoryPage) {
              let page = currentHistoryPage + 1;
              setCurrentHistoryPage(page);
            }
          }}>
          <span className={styles.Zero}>{totalHistoryPage - currentHistoryPage}</span>

          <img
            src={greaterIcon}
            alt="greaterIcon"
            width="12px"
          />
        </div>
      </div>

      <Modal
        isOpen={showBumpModal}
        isModalCenter customClass2={styles.bumpModalMaxWidth}
        customClass3={styles.rad}
      >
        <div className={styles.bumpConfirmationModal}>
          <div className="px-3 py-2 text-right w-100" style={{ color: 'black' }}>
            <i
              role="presentation"
              onClick={() => setShowBumpModal(false)}
              className="fa fa-times fs-30"
              aria-hidden="true"
            />
          </div>
          <div className={cn('text-center text-dark mb-3 ml-5 mr-5 fw-600')}>
            <p>{CUSTOM_MESSAGES().KDS_BUMP_CONFIRMATION}</p>
            <div>
              <button
                className={cn('rounded od-btn-primary color-dark btn-ripple btn35 w-40 m-3 border-dark')}
                style={{ border: '1px solid black' }}
                onClick={() => setShowBumpModal(false)}
              >
                {LABEL().NO}
              </button>
              <button
                style={{ border: '1px solid #0060FF' }}
                className={cn('rounded od-btn-primary color-white btn-ripple btn35 w-40 m-3', styles.popUpBtnColor)}
                onClick={() => {
                  setShowBumpModal(false);
                  handleBumpItemClick()
                }}
              >
                {LABEL().YES}
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isModalCenter
        isOpen={orderModeData?.isOpenn}
        customClass={'position-absolute p-2 px-3'}
        customClass2={'justify-content-center'}
        style={{
          border: '0px',
          backgroundColor: '#F5F5F5',
          height: window?.innerWidth < 1000 ? '10rem' : '15rem',
          width: '40vw',
          borderRadius: '0px'
        }}
      >
        <div className='d-flex justify-content-between p-2 px-3 mb-2'>
          <div className={cn(kdsStyles.item, 'text-dark')} style={{ fontWeight: '800', fontSize: columnCount <= 4 ? 'Max(1.7vw, 1.7vh)' : '' }}>
            {orderModeData?.itemName}
          </div>
          <div style={{ color: 'black', position: 'absolute', right: '7px', top: '-2px', cursor: 'pointer' }}>
            <i role='button' className="fa fa-times fs-30" onClick={() => onCloseLongPress()} />
          </div>
        </div>
        <div className='pt-1'
          role='button'
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setDragRushModalData((prev) => ({ ...prev, isOpen: true, modalName: LABEL().KDS_DRAG }));
            setOrderModeData({ isOpenn: false, isPdfOpen: true, itemName: '' });
          }}
        >
          <span className='p-2 pl-3'> <img src={kdsDragIcon} alt="pdf" /> </span>
          <span className='text-dark' style={{ fontSize: columnCount <= 4 ? 'Max(1.5vw, 1.5vh)' : '' }}> {LABEL().KDS_DRAG} </span>
        </div>
        <div role='button' className='pt-1'
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setDragRushModalData((prev) => ({ ...prev, isOpen: true, modalName: LABEL().KDS_RUSH }))
            setOrderModeData({ isOpenn: false, isPdfOpen: true, itemName: '' })
          }}
        >
          <span className='p-2 pl-3'> <img src={kdsRushIcon} alt="pdf" /> </span>
          <span className='text-dark' style={{ fontSize: columnCount <= 4 ? 'Max(1.5vw, 1.5vh)' : '' }}> {LABEL().KDS_RUSH} </span>
        </div>
      </Modal>
      <Modal
        isOpen={dragRushModalData?.isOpen}
        isModalCenter
        customClass2={'w-60 fw-600 fs-20'}
        style={{
          minHeight: checkIsDragRushModal(LABEL().KDS_RUSH) ? '45vh' : '65vh',
          backgroundColor: '#FFFFFF',
          justifyContent: 'space-between',
        }}
      >
        <div
          className='d-flex justify-content-between align-items-center py-2 px-2'
          style={{ backgroundColor: '#D8D8D8', color: '#4A4A4A' }}
        >
          <div className='d-flex align-items-center' style={{ fontWeight: '400', fontSize: '32px' }}>
            <span className='pr-3'>
              <img style={{ width: '44px', height: '44px' }} alt="drag-rush"
                src={checkIsDragRushModal(LABEL().KDS_DRAG) ? kdsDragIcon : kdsRushIcon}
              />
            </span>
            {dragRushModalData?.modalName}
          </div>
          <div className='w-10 d-flex justify-content-end pr-2'>
            <i role="role" className="fa fa-times fs-30"
              onClick={() => {
                setDragRushModalData({
                  isOpen: false, data: {}, modalName: '', checkData: {},
                  storeId: undefined, itemId: undefined, itemName: undefined,
                })
                setDragRushInputTime({ isConformationPopUpOpen: false, mins: 0 })
              }}
            />
          </div>
        </div>
        <div className='d-flex justify-content-between px-4 fs-20' style={{ color: '#4A4A4A' }}>
          <div>
            {dragRushModalData?.itemName}
          </div>
          <div
            className={cn('d-flex',
              checkIsDragRushModal(LABEL().KDS_RUSH) && generateDragRushModalTime() && 'w-40 justify-content-between'
            )}
          >
            {
              checkIsDragRushModal(LABEL().KDS_RUSH) && (
                <div>
                  <ExpoTime date={dragRushModalData?.data?.plannedStartDate} />
                </div>
              )
            }
            <div>
              {generateDragRushModalTime()}
            </div>
          </div>
        </div>
        {
          dragRushModalData?.modalName === LABEL().KDS_DRAG && <div className='py-1' style={{ color: '#4A4A4A', }}>
            <KdsTimePicker setTime={setDragRushInputTime} time={dragRushInputTime} format={'mm'} disableAll={!generateDragRushModalTime()} />
          </div>
        }
        <div className='d-flex justify-content-end' style={{ color: '#4A4A4A', }}>
          <div className='w-30 d-flex justify-content-end'>
            <button className='rounded btn-ripple p-2 w-90 my-3'
              style={{ backgroundColor: '#FFF', borderColor: '#0060FF', color: '#0060FF' }}
              onClick={() => {
                setDragRushModalData({
                  isOpen: false, data: {}, modalName: '', checkData: {},
                  storeId: undefined, itemId: undefined, itemName: undefined,
                })
                setDragRushInputTime({ isConformationPopUpOpen: false, mins: 0 })
              }}
            >
              {LABEL().CANCEL}
            </button>
          </div>
          <div className='w-30 d-flex justify-content-center'>
            <button className='rounded od-btn-primary color-white btn-ripple p-2 w-90 m-3'
              style={{
                border: 'none',
                backgroundColor: (dragRushModalData?.modalName === LABEL().KDS_DRAG && (generateDragRushModalTime() ?
                  // ((dragRushInputTime?.mins === "00:00:00" || dragRushInputTime?.mins === "") ? '#7B7B7B': '#0060FF') 
                  ((dragRushInputTime?.mins === 0 || dragRushInputTime?.mins == "") ? '#7B7B7B' : '#0060FF')
                  : '#7B7B7B')) || (generateDragRushModalTime() ? '#0060FF' : '#7B7B7B')
              }}
              disabled={
                (dragRushModalData?.modalName === LABEL().KDS_DRAG &&
                  // (!generateDragRushModalTime() || dragRushInputTime?.mins === "00:00:00" || dragRushInputTime?.mins === "")) || 
                  (!generateDragRushModalTime() || dragRushInputTime?.mins === 0 || dragRushInputTime?.mins == "")) ||
                (dragRushModalData?.modalName === LABEL().KDS_RUSH && !generateDragRushModalTime())
              }
              onClick={() => { setDragRushInputTime(prev => ({ ...prev, isConformationPopUpOpen: true })) }}
            >
              {LABEL().SUBMIT}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={dragRushInputTime?.isConformationPopUpOpen}
        isModalCenter customClass2={styles.bumpModalMaxWidth}
        style={{ border: '0px', borderRadius: '0px' }}
      >
        <div className={cn(styles.bumpConfirmationModal, 'fs-20 fw-400')}>
          <div className="px-2 py-2 text-right w-100">
            <i className="fa fa-times fs-30"
              role='button'
              style={{ color: '#4A4A4A' }}
              onClick={() => setDragRushInputTime(prev => ({ ...prev, isConformationPopUpOpen: false }))}
            />
          </div>
          <div className={cn('text-center text-dark mb-3 ml-5 mr-5')}>
            <p>
              {
                dragRushModalData?.modalName === LABEL().KDS_DRAG ? CUSTOM_MESSAGES().KDS_DRAG_CONFIRMATION : CUSTOM_MESSAGES().KDS_RUSH_CONFORMATION
              }
            </p>
            <div>
              <button
                className={cn('rounded od-btn-primary color-dark btn-ripple w-40 m-3 border-dark h-10 p-2')}
                style={{ border: '1px solid black' }}
                onClick={() => setDragRushInputTime(prev => ({ ...prev, isConformationPopUpOpen: false }))}
              >
                {LABEL().NO}
              </button>
              <button
                style={{ border: '1px solid #0060FF' }}
                className={cn('rounded od-btn-primary color-white btn-ripple w-40 m-3 h-10 p-2', styles.popUpBtnColor)}
                onClick={() => {
                  handleDragRushApiCall(dragRushModalData, dragRushInputTime, setDragRushInputTime, setDragRushModalData);
                  handleTicketExpandView();
                }}
              >
                {LABEL().YES}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default TicketExpandModal;